import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import TreeLogoRippleAnimation from './TreeLogoRippleAnimation';

export const Spinner = ({
  size,
  type = 'tree',
}: {
  type?: string | null;
  size?: number | null;
}) => {
  // create a switch for the different types of spinners

  if (!size) {
    size = type == 'circular' ? 50 : 400;
  }

  if (type === 'circular') {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress color='oceanTint' size={size} />
      </Box>
    );
  } else if (type === 'tree') {
    return (
      <Box
        sx={{
          position: 'fixed',
          width: '100vw',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <TreeLogoRippleAnimation />
      </Box>
    );
  } else {
    return <></>;
  }
};
